import Sitemap from 'assets/icons/fa/sitemap-solid.svg'

Sitemap.displayName = 'Sitemap'
export default Sitemap
